// extracted by mini-css-extract-plugin
export default {"row":"NotesTableRow_row__z6bXC","data":"NotesTableRow_data__JZjSe"};